import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import axios from "axios";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

export type LogoutRequest = {
  token: string;
};

const logout = async ({ token }: LogoutRequest) => {
  try {
    await axios.post(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/auth/logout`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  } catch (e) {
    const message = getApiResponseErrorMsg(e);

    throw new Error(message);
  }
};

export default logout;
